import React from "react";
import { House, CloudRain, Frame } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "PREMIUM SIDING",
  description: "Advanced protective systems engineered for maximum durability and thermal efficiency. Our siding solutions provide a maintenance-free exterior with a refined aesthetic.",
  icon: House,
  href: "/home-inspection-in-homestead-fl/"
}, {
  title: "SEAMLESS GUTTERS",
  description: "High-capacity drainage systems designed to mitigate foundation risks. Precision-fit installations ensuring absolute water management and long-term structural integrity.",
  icon: CloudRain,
  href: "/wind-mitigation-inspection/"
}, {
  title: "ARCHITECTURAL TRIM",
  description: "The definitive finishing element. Our custom-fabricated trim work provides a weather-tight seal while adding high-contrast architectural character to your home.",
  icon: Frame,
  href: "/condo-inspection/"
}];
export default function ExteriorServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="18499" id="our-services" ref={ref} className={`bg-background text-foreground py-24 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="font-sans text-3xl font-bold uppercase tracking-widest text-foreground sm:text-4xl">
            OUR CORE SOLUTIONS
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-base font-normal text-muted-foreground">
            Precision-engineered exterior systems designed for absolute protection and sophisticated aesthetic appeal.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {services.map((service, i) => <div key={i} data-index={i} className="group h-full">
              <Card className="border-border bg-card hover:shadow-xl hover:-translate-y-2 hover:border-primary relative flex h-full flex-col rounded-lg border transition-all duration-400 ease-out">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                    <service.icon className="text-secondary h-6 w-6 stroke-[1.5]" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-sans text-xl font-bold uppercase tracking-tight text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="font-sans text-base font-normal leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-4">
                  <Link to={service.href} className="font-mono text-primary hover:text-primary/80 group-hover:translate-x-1 inline-flex items-center text-sm font-bold uppercase tracking-widest transition-all duration-300">
                    LEARN MORE
                    <span className="ml-2 text-lg leading-none">→</span>
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}